import actionTypes from './actionTypes';

export const fetch = (fileName, params) => ({
  type: actionTypes.FETCH,
  payload: {
    fileName,
    params,
  },
});

export const fetching = () => ({
  type: actionTypes.FETCHING,
});

export const fetched = (data) => ({
  type: actionTypes.FETCHED,
  payload: {
    data,
  },
});

export const failed = (error) => ({
  type: actionTypes.FAILED,
  payload: {
    error,
  },
});

export const createBatch = (shipments) => ({
  type: actionTypes.CREATE_BATCH,
  payload: {
    shipments,
  },
});

export const createdBatch = (quotes) => ({
  type: actionTypes.CREATED_BATCH,
  payload: {
    quotes,
  },
});

export const createBatchFailed = () => ({
  type: actionTypes.CREATE_PATCH_FAILED,
});
